import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCarSide, faClipboardCheck, faStore, faCogs } from '@fortawesome/free-solid-svg-icons'
import CountUp from 'react-countup';
import { milhar } from '../../../utils/normalize'

// Cada numero real vem com o beneficio que ele representa, sem bloco frio de indicador.
const STATS = [
  { key: 'vehicles', icon: faCarSide, tone: 'orange', label: 'veículos com a história registrada' },
  { key: 'sales', icon: faClipboardCheck, tone: 'teal', label: 'atendimentos organizados no histórico' },
  { key: 'companies', icon: faStore, tone: 'amber', label: 'oficinas e autopeças conectadas' },
  { key: 'items', icon: faCogs, tone: 'violet', label: 'peças e serviços detalhados por item' },
]

const prefersReducedMotion = () =>
  typeof window !== 'undefined' &&
  window.matchMedia &&
  window.matchMedia('(prefers-reduced-motion: reduce)').matches

function StatValue({ value }) {
  const number = Number(value) || 0
  if (prefersReducedMotion()) return milhar(number)
  return <CountUp start={0} end={number} duration={1.6} separator='.' />
}

// As frases de escala so aparecem quando o numero real as sustenta.
const headline = (vehicles) =>
  Number(vehicles) >= 1000000
    ? 'Milhões de veículos com sua história registrada.'
    : 'Veículos de todo o Brasil com sua história registrada.'

const subline = (companies) =>
  Number(companies) >= 1000
    ? 'Milhares de empresas conectadas para tornar o cuidado com o veículo mais transparente.'
    : 'Empresas conectadas para tornar o cuidado com o veículo mais transparente.'

export default function StatsSection({ indicators, updatedAt }) {
  return (
    <section className='home-section home-proof' aria-labelledby='home-stats-title'>
      <div className='home-proof-panel'>
        <header className='home-section-header'>
          <span className='home-eyebrow home-eyebrow-light'>Uma rede que cuida do seu veículo</span>
          <h2 id='home-stats-title'>{headline(indicators.vehicles)}</h2>
          <p>{subline(indicators.companies)}</p>
        </header>
        <ul className='home-proof-grid'>
          {STATS.map(stat => (
            <li key={stat.key} className='home-proof-item'>
              <span className='home-proof-value'>
                <span className={`home-proof-icon home-proof-icon-${stat.tone}`} aria-hidden='true'>
                  <FontAwesomeIcon icon={stat.icon} />
                </span>
                <strong><StatValue value={indicators[stat.key]} /></strong>
              </span>
              <span className='home-proof-label'>{stat.label}</span>
            </li>
          ))}
        </ul>
        {updatedAt && <p className='home-proof-updated'>Números atualizados em {updatedAt}</p>}
      </div>
    </section>
  )
}
